import { cn } from "@/lib/utils";
import { type TTriffinBotFit, TriffinBot } from "@viable/triffin-bot";
import { landingChatAvatarShellClass } from "../../../shared/messaging/landing-bubble-styles";
import type { TChatMessageRole } from "./chat-playback";
import { SECTION_TWO_USER_INITIAL } from "./chat-transcript";

const CHAT_AVATAR_SIZE_CLASS = "h-10 w-10";
const CHAT_AVATAR_CLASS = cn(landingChatAvatarShellClass, CHAT_AVATAR_SIZE_CLASS);

type TChatAvatarProps = {
	messageRole: TChatMessageRole;
	className?: string;
	/** Defaults to the tight head crop used in chat; `full` keeps the whole figure in frame. */
	fit?: TTriffinBotFit;
};

export function ChatAvatar({ messageRole, className, fit = "avatar" }: TChatAvatarProps) {
	return (
		<div
			className={cn(
				CHAT_AVATAR_CLASS,
				{
					"relative mt-px bg-white": messageRole === "assistant",
				},
				className,
			)}
			aria-hidden="true"
		>
			{messageRole === "user" ? (
				<span className="flex h-full w-full items-center justify-center bg-teal-600 font-sans text-[20px] font-semibold leading-none tracking-[-0.02em] text-white">
					{SECTION_TWO_USER_INITIAL}
				</span>
			) : (
				<TriffinBot
					className="absolute inset-0 h-full w-full max-h-full max-w-full"
					fit={fit}
					shouldCycleSleepWake={false}
				/>
			)}
		</div>
	);
}
